module.exports = __webpack_public_path__ + "static/img/zup.88fa373.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zup.png
// module id = /t0s
// module chunks = 4